export default "__VITE_ASSET__1108fe5d__"